var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1953,
    cy: 12.6094,
    r: 12.5,
    fill: "#EEF6ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3055_48433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6871 12.6065L15.4371 17.8565C15.4371 17.8565 14.5321 18.7616 13.9371 19.3565C9.43715 23.8565 2.68715 17.1065 7.18715 12.6065C7.85128 11.9424 8.68715 11.1065 8.68715 11.1065C8.68715 11.1065 11.8083 7.98537 13.9371 5.85653C16.9371 2.85653 21.4371 7.35653 18.4371 10.3565C16.9276 11.866 13.1871 15.6065 13.1871 15.6065C13.1871 15.6065 12.173 16.6207 11.6871 17.1065C10.1871 18.6065 7.93715 16.3565 9.43715 14.8565C9.81252 14.4812 10.9371 13.3565 10.9371 13.3565M10.6714 13.6223C10.4755 13.8182 16.1871 8.10653 16.1871 8.10653",
    stroke: "#58A84A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3055_48433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.19531 3.60938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentGreen);
export default __webpack_public_path__ + "static/media/attachment-green.aaccbc16cd52ef71456e64f493a01fe2.svg";
export { ForwardRef as ReactComponent };